import React from 'react'; 
import PropTypes from 'prop-types';
const ScheduleDate = ({ selectedSchedule, lookup }) => {
    return (
        <div id="schedule">
            <h4 className="text-primary">Next steps</h4>
            <p>
                <b>{lookup.title}</b>
            </p>
            {selectedSchedule ?
                <p>
                    {lookup.scheduledDate}
                    <br />
                    <b> {selectedSchedule}</b>
                    <br />
                </p>
                :
                null
            }
            <p>{lookup.callForConfirmingServiceDate}</p>
        </div>
    );
};

ScheduleDate.propTypes = {
    selectedSchedule: PropTypes.object.isRequired,
    lookup: PropTypes.object.isRequired
};

export default ScheduleDate;